import { useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import DocsLayout from './DocsLayout';
import DocsSidebar from './DocsSidebar';
import DocsContent from './DocsContent';
import DocsNav from './DocsNav';

function DocsContainer({ sections, basePath }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { sectionId } = useParams();


  const activeSectionId = sectionId || (sections.length > 0 ? sections[0].id : null);
  const activeSection = sections.find(sec => sec.id === activeSectionId);


  useEffect(() => {
    if (sectionId && !sections.some(sec => sec.id === sectionId)) {
      navigate(`${basePath}/${sections[0].id}`, { replace: true });
    }
  }, [sectionId, sections, basePath, navigate]);

  // Handle smooth scroll for hashes (#chapters)
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => element.scrollIntoView({ behavior: 'smooth' }), 100);
      }
    }
  }, [location.hash, activeSectionId]);

  return (
    <DocsLayout
      leftSidebar={
        <DocsSidebar
          sections={sections}
          activeSectionId={activeSectionId}
          basePath={basePath} 
        />
      }
      content={<DocsContent sections={activeSection ? [activeSection] : []} />}
      rightSidebar={
        <DocsNav 
          chapters={activeSection?.chapters || []} 
          sectionId={activeSectionId} 
          basePath={basePath}
        />
      }
    />
  );
}

export default DocsContainer;